export const FETCH_DEVICE_LOGS_LOADING = "FETCH_DEVICE_LOGS_LOADING";
export const FETCH_DEVICE_LOGS_SUCCESS = "FETCH_DEVICE_LOGS_SUCCESS";
export const FETCH_DEVICE_LOGS_FAILED = "FETCH_DEVICE_LOGS_FAILED";
export const CLEAR_DEVICE_LOGS = "CLEAR_DEVICE_LOGS;";
